import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue"
import _imports_0 from '../../assets/images/trial_modal_pic.png'


const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "main-title" }
const _hoisted_6 = { class: "sub-title" }
const _hoisted_7 = { class: "banner-app-name" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_9 = { class: "bottom-text" }

import { onMounted, reactive, ref } from 'vue';
import { EnvConfig } from '@/env';
import { message } from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import { JeecgAuthService } from '@do/do-auth-web-client';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { AuthService } from '../../service/auth_service';

interface IFormData {
    userName: string;
    phone: string;
    email: string;
    tenantAlias: string;
    captcha: string;
    industry: {
        id: string;
        childId: string;
        name: string;
    };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'register',
  setup(__props) {

const { t } = useI18n();

const formData = reactive<IFormData>({
    userName: '',
    phone: '',
    email: '',
    tenantAlias: '',
    captcha: '',
    industry: {
        id: '',
        childId: '',
        name: '',
    },
});
const formRef = ref();
const route = useRoute();
const router = useRouter();
const btnTxt = ref(t('获取验证码'));
const disabled = ref(false);
const time = ref(60);

const returnUrlRef = ref('');
const bVisible = ref(true);
const intervalId = ref();
const industries = ref<{ id: string; name: string; childId: string }[]>([]);
onMounted(async () => {
    fetch(`${EnvConfig.getBaseUrl()}/doMistServer/communityUser/findByCondition`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            pid: '1250472583391621120',
            includeAllChildren: true,
            auth: 1,
            deep: 5,
            sortVo: { orderBy: 'sort', sort: 'asc' },
        }),
    }).then((res) => {
        if (res.status === 200) {
            res.json().then((data) => {
                industries.value = data.result.map((item: any) => ({
                    id: item.id,
                    childId: item.children?.[0].id,
                    name: item.name,
                }));
                formData.industry = industries.value[0];
            });
        }
    });
});

const _getCode = async (): Promise<void> => {
    await (formRef.value as ANY).validate('phone');
    const { phone } = formData;
    _countDown();
    const key = 'updatable';
    message.loading({ content: t('短信发送中'), key, duration: 0 });
    try {
        const data = await JeecgAuthService.sms({
            mobile: phone,
            smsmode: '3',
        });

        message.success({ content: t('验证码已发送'), key });
    } catch (ex: any) {
        message.error({ content: `${t('短信发送失败')}: ${ex.message}`, key });
        clearInterval(intervalId.value);
        btnTxt.value = t('获取验证码');
        disabled.value = false;
    } finally {
    }
};

const _countDown = () => {
    btnTxt.value = `${time.value}s`;
    disabled.value = true;
    intervalId.value = setInterval(() => {
        time.value--;
        btnTxt.value = `${time.value}s`;
        if (time.value <= 0) {
            clearInterval(intervalId.value);
            btnTxt.value = t('获取验证码');
            disabled.value = false;
            if (time.value === 0) {
                time.value = 60;
            }
        } else {
            disabled.value = true;
        }
    }, 1000);
};

const submitForm = (values: IFormData) => {
    axios
        .post(
            `${EnvConfig.getBaseUrl()}/v3/sys/user/addCommunity`,
            {
                ...values,
                industry: values.industry.id,
                industryName: values.industry.name,
                workscene: values.industry.childId,
                userStatus: 4,
                selectedroles: '1810194602511429634',
                realname: values.userName,
                extendStatus: 1,
                doGold: 100,
                userName: values.phone,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        )
        .then(async ({ data }) => {
            if (data?.code === 200) {
                axios
                    .get(`${EnvConfig.getBaseUrl()}/doMistServer/communityUser/initUserCommunity`, {
                        params: {
                            username: values.phone,
                        },
                    })
                    .then(async ({ data }) => {
                        if (data.code === 200) {
                            console.log('社区版注册');
                            message.success(t('账号注册成功，即将跳转登录页面'));
                            const returnUrl = encodeURIComponent(
                                `${EnvConfig.getHomeUrl2()}/shanshe-community/index?tenantId=0&app=shanshe-community`,
                            );
                            router.push({ path: '/', query: { returnUrl, isCommunity: '1' } });
                        } else {
                            message.error(t(data.message || data.msg));
                        }
                    })
                    .catch((error) => {
                        // 处理错误
                        console.error(error);
                        message.error(t('请求失败，请重试'));
                    });
                if (EnvConfig.getEnv() === 'production') {
                    const { bdVid } = route.query;
                    await AuthService.setUserInCrm({
                        industry: values.industry.name,
                        userName: values.userName,
                        phone: values.phone,
                        customerName: values.tenantAlias,
                        source: bdVid ? 'SEM-社区版注册' : '社区版注册',
                        allocated: false,
                    });
                }
            } else {
                message.error(t(data.message || data.msg));
            }
        });
};

const exitUse = () => {
    // Implement exit logic here
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('欢迎来到')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('进入闪设，开启智能设计')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('闪设')), 1),
        _hoisted_8
      ]),
      _createVNode(_component_a_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        name: "sb",
        onFinish: submitForm,
        layout: "vertical",
        class: "register-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: _ctx.$t('用户名'),
            name: "userName",
            rules: [{ required: true, message: _ctx.$t('请输入10位以内字符'), pattern: '^.{0,10}$' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.userName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.userName) = $event)),
                placeholder: _ctx.$t('请输入用户名')
              }, null, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["label", "rules"]),
          _createVNode(_component_a_form_item, {
            label: _ctx.$t('手机号'),
            name: "phone",
            rules: [
                        {
                            required: true,
                            message: _ctx.$t('请输入正确的手机号'),
                            pattern: /^1[3456789]\d{9}$/,
                        },
                    ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.phone,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formData.phone) = $event)),
                placeholder: _ctx.$t('请输入手机号')
              }, null, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["label", "rules"]),
          _createVNode(_component_a_form_item, {
            label: _ctx.$t('验证码'),
            name: "captcha",
            class: "form-item code",
            rules: [{ required: true, message: _ctx.$t('请输入验证码') }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                id: "code",
                placeholder: _ctx.$t('请输入短信验证码'),
                value: formData.captcha,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formData.captcha) = $event))
              }, null, 8, ["placeholder", "value"]),
              _createVNode(_component_a_button, {
                onClick: _getCode,
                disabled: disabled.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(btnTxt.value), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label", "rules"]),
          _createVNode(_component_a_form_item, {
            label: _ctx.$t('公司名称'),
            name: "tenantAlias",
            rules: [{ required: true, message: _ctx.$t('请输入公司名称') }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formData.tenantAlias,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formData.tenantAlias) = $event)),
                placeholder: _ctx.$t('请输入公司名称')
              }, null, 8, ["value", "placeholder"])
            ]),
            _: 1
          }, 8, ["label", "rules"]),
          _createVNode(_component_a_form_item, {
            label: _ctx.$t('所在行业'),
            name: "industry"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: formData.industry,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formData.industry) = $event)),
                style: {"display":"flex","justify-content":"space-between"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industries.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_radio_button, {
                      key: index,
                      value: item
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, { style: {"text-align":"center","margin-top":"68px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                class: "register-btn",
                type: "primary",
                "html-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('立即注册')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.$t('已注册账号')) + " ", 1),
            _createVNode(_component_RouterLink, {
              to: { path: '/', query: { ..._unref(route).query } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('立即登录')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})